import { render, staticRenderFns } from "./board-setting.vue?vue&type=template&id=4cebb788&"
import script from "./board-setting.vue?vue&type=script&lang=js&"
export * from "./board-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports